var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTabs)?_c('reverse-relevance-tabs',{attrs:{"control":_vm.control}}):_c('reverse-relevance-list',{attrs:{"control":_vm.control}})}
var staticRenderFns = []

export { render, staticRenderFns }